import * as React from 'react';
import type { SVGProps } from 'react';
const SvgServices = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#services_svg__a)">
      <path
        fill="#263E6A"
        d="M10.936 6.578c0-.617.473-1.015 1.083-1.015s1.083.398 1.083 1.015c0 .592-.473 1.014-1.083 1.014s-1.083-.422-1.083-1.014m.287 2.922h1.568v9.282h-1.568zM21.6 12a9.6 9.6 0 0 0-2.213-6.132.322.322 0 0 0-.493.41 8.97 8.97 0 0 1 2.065 5.722c0 4.94-4.02 8.958-8.959 8.958-4.94 0-8.958-4.019-8.958-8.958 0-4.94 4.018-8.958 8.958-8.958 1.796 0 3.528.53 5.009 1.53a.32.32 0 1 0 .358-.532A9.55 9.55 0 0 0 12 2.4c-5.294 0-9.6 4.307-9.6 9.6 0 5.294 4.306 9.6 9.6 9.6s9.6-4.306 9.6-9.6"
      />
    </g>
    <defs>
      <clipPath id="services_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgServices;
